import { useDarkMode } from "../../../context/ThemeContext";
import { getThemeClasses } from "../../../utils/ThemeClasses";

export default function InformacionSection() {
  const { isDarkMode } = useDarkMode();
  const themeClasses = getThemeClasses(isDarkMode);

  const inputClasses = `w-full p-3 rounded-lg border ${themeClasses.cardBorder} ${isDarkMode ? 'bg-dark-surface' : 'bg-white'} ${themeClasses.text} focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500`;
  const selectClasses = `w-full p-3 rounded-lg border ${themeClasses.cardBorder} ${isDarkMode ? 'bg-dark-surface' : 'bg-white'} ${themeClasses.text} focus:outline-none focus:ring-2 focus:ring-primary-500/50 focus:border-primary-500 appearance-none cursor-pointer`;

  return (
    <div className="w-full h-full p-4 sm:p-6 overflow-auto">
      {/* Page Header */}
      <div className="mb-4 sm:mb-6">
        <h1 className={`text-xl sm:text-2xl font-bold ${themeClasses.text}`}>
          Información de facturación
        </h1>
        <p className={`text-xs sm:text-sm ${themeClasses.textSecondary} mt-1`}>
          Datos para generar tus facturas y comprobantes fiscales.
        </p>
      </div>

      {/* Info Banner */}
      <div className={`${isDarkMode ? 'bg-blue-500/10 border-blue-500/30' : 'bg-blue-50 border-blue-200'} border rounded-xl p-3 sm:p-4 mb-4 sm:mb-6`}>
        <div className="flex items-start space-x-3">
          <i className="ri-information-line text-blue-500 text-xl mt-0.5"></i>
          <div>
            <p className={`font-medium ${themeClasses.text}`}>
              Los cambios aplicarán a futuras facturas
            </p>
            <p className={`text-sm text-blue-600 dark:text-blue-400 mt-1`}>
              Las modificaciones en tu información fiscal se reflejarán en las facturas generadas a partir de la próxima fecha de facturación.
            </p>
          </div>
        </div>
      </div>

      {/* Form */}
      <div className={`${themeClasses.cardBg} border ${themeClasses.cardBorder} rounded-xl p-4 sm:p-6`}>
        
        {/* Datos de la empresa */}
        <div className="mb-8">
          <h2 className={`text-base font-semibold ${themeClasses.text} mb-4`}>
            Datos de la empresa
          </h2>
          
          <div className="space-y-4">
            <div>
              <label className={`block text-sm ${themeClasses.text} mb-1`}>
                Razón social <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                defaultValue="Company S.A. de C.V."
                className={inputClasses}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className={`block text-sm ${themeClasses.text} mb-1`}>
                  RFC / Tax ID <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue="TDU940325HG8"
                  className={inputClasses}
                />
              </div>
              <div className="relative">
                <label className={`block text-sm ${themeClasses.text} mb-1`}>
                  Régimen fiscal <span className="text-red-500">*</span>
                </label>
                <select className={selectClasses} defaultValue="601">
                  <option value="601">601 - General de Ley Personas Morales</option>
                  <option value="603">603 - Personas Morales con Fines no Lucrativos</option>
                  <option value="612">612 - Personas Físicas con Actividades Empresariales</option>
                </select>
                <i className={`ri-arrow-down-s-line absolute right-3 top-10 ${themeClasses.textSecondary}`}></i>
              </div>
            </div>

            <div className="relative">
              <label className={`block text-sm ${themeClasses.text} mb-1`}>
                País <span className="text-red-500">*</span>
              </label>
              <select className={selectClasses} defaultValue="MX">
                <option value="MX">México</option>
                <option value="US">Estados Unidos</option>
                <option value="CA">Canadá</option>
              </select>
              <i className={`ri-arrow-down-s-line absolute right-3 top-10 ${themeClasses.textSecondary}`}></i>
            </div>
          </div>
        </div>

        {/* Dirección fiscal */}
        <div className="mb-8 pt-6 border-t border-gray-200 dark:border-gray-700">
          <h2 className={`text-base font-semibold ${themeClasses.text} mb-4`}>
            Dirección fiscal
          </h2>
          
          <div className="space-y-4">
            <div>
              <label className={`block text-sm ${themeClasses.text} mb-1`}>
                Calle y número <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                defaultValue="Av. Insurgentes Sur 1458"
                className={inputClasses}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className={`block text-sm ${themeClasses.text} mb-1`}>
                  Colonia <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue="Actipan"
                  className={inputClasses}
                />
              </div>
              <div>
                <label className={`block text-sm ${themeClasses.text} mb-1`}>
                  Ciudad <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue="Ciudad de México"
                  className={inputClasses}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="relative">
                <label className={`block text-sm ${themeClasses.text} mb-1`}>
                  Estado / Provincia <span className="text-red-500">*</span>
                </label>
                <select className={selectClasses} defaultValue="CDMX">
                  <option value="CDMX">Ciudad de México</option>
                  <option value="JAL">Jalisco</option>
                  <option value="NL">Nuevo León</option>
                </select>
                <i className={`ri-arrow-down-s-line absolute right-3 top-10 ${themeClasses.textSecondary}`}></i>
              </div>
              <div>
                <label className={`block text-sm ${themeClasses.text} mb-1`}>
                  Código postal <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  defaultValue="03230"
                  className={inputClasses}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Información de contacto */}
        <div className="mb-8 pt-6 border-t border-gray-200 dark:border-gray-700">
          <h2 className={`text-base font-semibold ${themeClasses.text} mb-4`}>
            Información de contacto
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className={`block text-sm ${themeClasses.text} mb-1`}>
                Correo electrónico <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                defaultValue="facturacion@company.com"
                className={inputClasses}
              />
            </div>
            <div>
              <label className={`block text-sm ${themeClasses.text} mb-1`}>
                Teléfono
              </label>
              <input
                type="tel"
                defaultValue="+52 55 1234 5678"
                className={inputClasses}
              />
            </div>
          </div>
        </div>

        {/* Preferencias de facturación */}
        <div className="mb-8 pt-6 border-t border-gray-200 dark:border-gray-700">
          <h2 className={`text-base font-semibold ${themeClasses.text} mb-4`}>
            Preferencias de facturación
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div className="relative">
              <label className={`block text-sm ${themeClasses.text} mb-1`}>
                Uso de CFDI
              </label>
              <select className={selectClasses} defaultValue="G03">
                <option value="G03">G03 - Gastos en general</option>
                <option value="G01">G01 - Adquisición de mercancías</option>
                <option value="G02">G02 - Devoluciones, descuentos o bonificaciones</option>
              </select>
              <i className={`ri-arrow-down-s-line absolute right-3 top-10 ${themeClasses.textSecondary}`}></i>
            </div>
            <div className="relative">
              <label className={`block text-sm ${themeClasses.text} mb-1`}>
                Método de pago
              </label>
              <select className={selectClasses} defaultValue="PUE">
                <option value="PUE">PUE - Pago en una sola exhibición</option>
                <option value="PPD">PPD - Pago en parcialidades o diferido</option>
              </select>
              <i className={`ri-arrow-down-s-line absolute right-3 top-10 ${themeClasses.textSecondary}`}></i>
            </div>
          </div>

          <div>
            <label className={`block text-sm ${themeClasses.text} mb-1`}>
              Observaciones fiscales
            </label>
            <textarea
              rows={3}
              placeholder="Agrega notas o instrucciones especiales para tus facturas..."
              className={`${inputClasses} resize-none`}
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-4 sm:pt-6 border-t border-gray-200 dark:border-gray-700">
          <p className={`text-xs sm:text-sm ${themeClasses.textSecondary} flex items-center order-2 sm:order-1`}>
            <i className="ri-time-line mr-1"></i>
            Última actualización: 15 de marzo, 2024
          </p>
          <div className="flex items-center gap-3 order-1 sm:order-2 w-full sm:w-auto">
            <button className={`flex-1 sm:flex-none px-4 sm:px-6 py-2.5 border ${themeClasses.cardBorder} rounded-xl ${themeClasses.buttonText} ${themeClasses.buttonHover} transition-all font-medium text-sm sm:text-base`}>
              Cancelar
            </button>
            <button className="flex-1 sm:flex-none flex items-center justify-center space-x-2 px-4 sm:px-6 py-2.5 bg-primary-500 hover:bg-primary-400 text-gray-900 rounded-xl transition-all font-medium text-sm sm:text-base">
              <i className="ri-save-line"></i>
              <span>Guardar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
